// extracted by mini-css-extract-plugin
export default {"ScenariosTable-wrapper":"ScenariosTable_ScenariosTable-wrapper__kNLdL"};